type Env = 'local' | 'nightly' | 'staging' | 'testnet' | 'prod';

type Flag =
  | 'points-analytics-dashboard-enabled'
  | 'points-enabled'
  | 'account-usernames-enabled'
  | 'hide-account-usernames-enabled'
  | 'localization-enabled'
  | 'order_book-100ms-snapshots-enabled'
  | 'order_book-200ms-throttling-enabled'
  | 'stop-orders-enabled'
  | 'max-withdrawable-enabled'
  | 'position-liquidation-price-col-enabled'
  | 'reduce-only-enabled';

const FEATURE_FLAGS: Record<Flag, Record<Env, unknown>> = {
  'points-analytics-dashboard-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
  'points-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
  'account-usernames-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
  'hide-account-usernames-enabled': {
    local: false,
    nightly: false,
    staging: false,
    testnet: false,
    prod: false,
  },
  'localization-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
  'order_book-100ms-snapshots-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
  'order_book-200ms-throttling-enabled': {
    local: false,
    nightly: false,
    staging: false,
    testnet: false,
    prod: false,
  },
  'stop-orders-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
  'max-withdrawable-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
  'position-liquidation-price-col-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
  'reduce-only-enabled': {
    local: true,
    nightly: true,
    staging: true,
    testnet: true,
    prod: true,
  },
};

const FeatureFlags = {
  getBooleanValue(flag: Flag, defaultValue: boolean): boolean {
    return Boolean(getValue(flag, defaultValue));
  },
};

function getValue(flag: Flag, defaultValue: unknown): unknown {
  if ("false" === 'true') return true;
  if ("prod" === 'test-runner') return true;
  if (String("https://app.paradex.trade").includes('localhost')) return FEATURE_FLAGS[flag].local;
  return FEATURE_FLAGS[flag]["prod" as Env] ?? defaultValue;
}

export { FeatureFlags };
